import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type ResendActivationPayload } from './types';

/**
 * Resends a supplier activation request, optionally with a new supplier email.
 *
 * @param reqId - The activation request ID to resend.
 * @param payload - Optional body. When omitted the original email is reused.
 * @param options - Optional ky request options (e.g., abort signal).
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/post_resend_activation_suppliers_actions__req_id__resend_post
 */
export const resendActivation = async (
  reqId: UUID,
  payload?: ResendActivationPayload,
  options?: KyRequestOptions,
) => {
  await vestigasApi.post(ENDPOINT.SUPPLIER.RESEND_ACTIVATION(reqId), {
    ...options,
    ...(payload != null ? { json: payload } : {}),
  });
};
